<template>
  <!-- Dialog for SUCCESS - results -->
  <v-dialog max-width="600px" v-model="displayResults">
    <v-card class="d-block">
      <v-card-title
        class="pt-7 secondary--text font-weight-bold text-center d-block"
        style="font-size: 30pt;"
      >Done.</v-card-title>
      <v-card-text class="headline mt-7 text-center">
        <p>{{message}}</p>
      </v-card-text>
      <v-card-text v-if="displayServerResult">
        This was the result from the server:
        <code class="d-block white--text success">{{result}}</code>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" text @click="internal_result = null">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- DIALOG SUCCESS END -->
</template>
<script>
export default {
  name: "ResultsDialog",
  props: {
    result: null,
    message: String,
    displayServerResult: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      internal_result: !!this.result
    };
  },
  computed: {
    displayResults() {
      return !!this.internal_result;
    }
  },
  watch: {
    result: function(newResult) {
      this.internal_result = newResult;
    }
  }
};
</script>